import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { DistributionEarnings } from '@webapp/types/ui/earnings/distribution-earnings';

import EarningsListCtrl from './earnings-list';

interface StreamListTotalCtrlProps {
  className?: string;
  isPro?: boolean;
  data: DistributionEarnings[];
}

export const StreamListTotalCtrl: React.FC<StreamListTotalCtrlProps> = ({
  className,
  isPro,
  data,
}) => {
  return (
    <div className={className}>
      {data
        .sort((a, b) => b.revenue.subtract(a.revenue).getAmount())
        .map((category, i) => (
          <EarningsListCtrl
            key={`streams-${i}`}
            title={category.category}
            subtitle={<Translate id="USER_PROFILE.WALLET.EARNINGS.ALL" />}
            revenue={category.revenue}
            isPro={isPro}
          />
        ))}
    </div>
  );
};

export default StreamListTotalCtrl;
